module.exports = __webpack_public_path__ + "img/Lumina.c939b899.png";